{
    "features-debit-card-explore-discounts": {
        "meta": {
            "title": "Explorar descuentos - MAJORITY",
            "description": ""
        },
        "hero": {
            "title": "Descuentos MAJORITY",
            "body": "Paga con orgullo y ahorra en cualquiera de nuestros socios de descuentos locales. ¡Gasta menos en alimentos, restaurantes y más!"
        },
        "label": {
            "no_discount": "Estamos obteniendo más descuentos increíbles para ti. ¡Vuelve pronto!"
        }
    }
}